require('./categoriesModal.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const {connect} = require('react-redux');
// @ commons
const { formatText } = require('core/i18n').i18n;
// @ constants
const { categoryOptions } = require('constants/categories');
// @ components
const OKModal = require('components/commons/OKModal/OKModal');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ actions
const categoryActions = require('actions/categoryUpdate');

class CategoriesModalOld extends React.Component {
    constructor (props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCategorySelection = this.handleCategorySelection.bind(this);
        this.handleSubcategorySelection = this.handleSubcategorySelection.bind(this);
    }

    handleCategorySelection(evt){
        const { setCategory } = this.props;
        const category = evt.value;

        if (category) {
            setCategory(category);
        }
    }

    handleSubcategorySelection(evt) {
        const { setSubcategory } = this.props;
        const subcategory = evt.value;

        if (subcategory) {
            setSubcategory(subcategory)
        }
    }

    render() {
        const { immCategoryUpdate, handleClose, handleChangeCategory, byCategory } = this.props;

        const labelCategory = formatText('myMoneyTransactions-categorySelect');
        const labelSubcategory = formatText('myMoneyTransactions-subcategorySelect');

        const isUpdating =  immCategoryUpdate.get('isUpdating');

        const content = (
            <React.Fragment>
                <div className="categories-modal__select-category">
                    <OKSelect
                        label={labelCategory}
                        options={categoryOptions()}
                        value={immCategoryUpdate.get('category')}
                        searchable={false}
                        clearable={false}
                        onChange={this.handleCategorySelection}
                        disabled={isUpdating}
                    />
                </div>
                <div className="categories-modal__select-subcategory">
                    <OKSelect
                        label={labelSubcategory}
                        options={immCategoryUpdate.get('subcategoryList').toJS()}
                        value={immCategoryUpdate.get('subcategory')}
                        searchable={false}
                        clearable={false}
                        onChange={this.handleSubcategorySelection}
                        disabled={isUpdating}
                    />
                </div>
            </React.Fragment>
        );

        return (
            <OKModal
                content={content}
                description={`"${immCategoryUpdate.get('description')}"`}
                footerType="navigation"
                isOpen={immCategoryUpdate.get('isOpen')}
                loading={isUpdating}
                onCloseCallback={handleClose}
                onPrimaryButtonClick={() => handleChangeCategory(byCategory)} 
                onSecondaryButtonClick={handleClose}
                primaryButtonText="myMoneyTransactions-changeCategory"
                secondaryButtonText="filterDate-cancel"
                title="myMoneyTransactions-modifyModal"
            />
        );
    }

}

CategoriesModalOld.propTypes = {
    immCategoryUpdate: PropTypes.object,
    handleChangeCategory: PropTypes.func,
    handleClose: PropTypes.func,
    setCategory: PropTypes.func,
    setSubcategory: PropTypes.func,
    byCategory: PropTypes.bool
};

CategoriesModalOld.defaultProps = {
    byCategory: false
}

module.exports.constructor = CategoriesModalOld;
module.exports.CategoriesModalOld = connect(
    state => ({
        immCategoryUpdate: state.categoryUpdate
    }),
    {
        handleClose: categoryActions.close,
        setCategory: categoryActions.setCategory,
        setSubcategory: categoryActions.setSubcategory,
        handleChangeCategory: categoryActions.requestChangeCategory
    }
)(CategoriesModalOld);